const typography = {
  fontFamily: 'Figtree',
  fontSize: 16,
  fontWeightRegular: 400,
  fontWeightMedium: 400,
  fontWeightBold: 800,
  h1: {
    lineHeight: '36px',
    fontSize: 30,
    fontWeight: 800,
    letterSpacing: -0.8,
  },
  h2: {
    lineHeight: '32px',
    fontSize: 26,
    fontWeight: 800,
    letterSpacing: -0.8,
  },
  h3: {
    lineHeight: '150%',
    fontSize: '18px',
    fontWeight: 800,
    letterSpacing: -0.5,
  },
  h4: {
    lineHeight: '150%',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: -0.5,
  },
  h5: {
    lineHeight: '20px',
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: -0.25,
  },
  h6: {
    lineHeight: '20px',
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 0,
  },
  subtitle1: {
    lineHeight: '26px',
    fontSize: 18,
    fontWeight: 800,
    letterSpacing: 0,
  },
  subtitle2: {
    lineHeight: '24px',
    fontSize: 18,
    fontWeight: 300,
    letterSpacing: 0,
  },
  body1: {
    lineHeight: '24px',
    fontSize: 16,
    fontWeight: 300,
    letterSpacing: 0,
  },
  body2: {
    // used by CssBaseline for <body> element
    // Button, Table, Input Fields
    lineHeight: '20px',
    fontSize: 14,
    fontWeight: 300,
    letterSpacing: 0,
  },
  caption1: {
    lineHeight: '16px',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 0,
  },
  caption2: {
    lineHeight: '16px',
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0,
  },
  strikethrough: {
    lineHeight: '16px',
    fontSize: 12,
    fontWeight: 300,
    letterSpacing: 0,
  },
  button: {
    // this is not used by ui kit as a typography option but does override mui styles
    lineHeight: '20px',
    fontSize: 14,
    fontWeight: 300,
    letterSpacing: 0,
  },
};

export default typography;
